import React from 'react';
import { ContactUsPageTypes } from '..';
import { FormikForm } from './FormikForm';
import { useVariant } from '../hooks/VariantContext';

export const ContactForm = ({
  emailAddress,
}: ContactUsPageTypes.TContactDetails) => {
  const variant = useVariant();
  return (
    <div className="ContactForm">
      {variant === 'newContactUsDarkTheme' && (
        <div className="messages">
          <h4>Send Us a Message</h4>
        </div>
      )}
      <FormikForm emailAddress={emailAddress} />
    </div>
  );
};
